import { getJson } from "./networkService";

export async function getBottleOrderDashboard(fromDate,toDate,accountNumber, page, filter) {
  return getJson(`/bottleorders/account/${accountNumber}/dashboard?page=${page}&filter=${filter}&fromDate=${fromDate}&toDate=${toDate}`);
}

export async function getBottleOrder(orderNumber) {
  return getJson(`/bottleorders/${orderNumber}`);
}
